import React from 'react';
import cn from 'classnames';

const QuestionNavigatorPreview = ({ questionCurrentIndex, total }) => {
  return (
    <div className={cn('h-full')}>
      <div
        className={cn(
          'bg-bluebook-gray-900 border-[1px] border-white rounded-[7px] text-white px-px py-1.5',
        )}
        accessibility={{
          'aria-label': `Question Navigator Question ${questionCurrentIndex} of ${total}`,
        }}
      >
        <div
          className={cn(
            'h-[32px] flex justify-between items-center font-semibold text-[15px] mx-[10px]',
          )}
        >
          Question {questionCurrentIndex} of {total}
        </div>
      </div>
    </div>
  );
};

export default QuestionNavigatorPreview;
